import { createAppAsyncThunk, logger } from 'shared';

import { fetchPackages } from '../../api/requests';
import { actionTypes } from '../action-types';
import { actions } from '../reducer';

const getPackagesHandler =
  (actionType: string) =>
  async (_: void, { rejectWithValue, dispatch }: any) => {
    try {
      const packages = await fetchPackages();

      if (Object.keys(packages).length) {
        dispatch(actions.setPackages(packages));
      }

      return null;
    } catch (err) {
      logger(actionType, err);
      return rejectWithValue(err);
    }
  };

export const getPackages = createAppAsyncThunk(actionTypes.GET_PACKAGES, getPackagesHandler(actionTypes.GET_PACKAGES));
export const getInitialPackages = createAppAsyncThunk(
  actionTypes.GET_INITIAL_PACKAGES,
  getPackagesHandler(actionTypes.GET_INITIAL_PACKAGES),
);
